import { render, staticRenderFns } from "./TranshipmentWeightTariffFormDialog.vue?vue&type=template&id=169721d8&scoped=true"
import script from "./TranshipmentWeightTariffFormDialog.vue?vue&type=script&lang=js"
export * from "./TranshipmentWeightTariffFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentWeightTariffFormDialog.vue?vue&type=style&index=0&id=169721d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169721d8",
  null
  
)

export default component.exports